import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { VoiceUpdateInterface } from '@/components/voice/VoiceUpdateInterface';
import ChatLayout from '@/components/chat/layout/ChatLayout';
import { ChatInterfaceProvider } from '@/contexts/ChatInterfaceContext';

export const VoiceUpdate: React.FC = () => {
  const { positId } = useParams<{ positId: string }>();
  const navigate = useNavigate();

  if (!positId) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-purple-50 to-indigo-100 flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-gray-800 mb-4">Invalid Posit ID</h1>
          <button 
            onClick={() => navigate('/')}
            className="bg-purple-600 hover:bg-purple-700 text-white px-6 py-2 rounded-lg"
          >
            Go Home
          </button>
        </div>
      </div>
    );
  }

  return (
    <ChatInterfaceProvider>
      <ChatLayout 
        mobileTitle="Voice Update"
        showMobileHeader={false}
      >
        <VoiceUpdateInterface 
          positId={positId}
          onEndCall={() => navigate(`/update-posit/${positId}`)}
        />
      </ChatLayout>
    </ChatInterfaceProvider>
  );
}; 